import { Button, Typography } from "@vaporfi/uikit";
import Link from "next/link";

export const ApeRushBanner = () => {
	return (
		<div className="w-full rounded-lg border border-blue-500 py-2 px-4">
			<div className="flex w-full items-center justify-between gap-4">
				<Typography size="base" className="flex-1">
					As a top 50 holder of tokens from ApeRush, you can earn rewards from
					the fees generated by liquidity pools.
				</Typography>
				<Link href="#" target="_blank" passHref legacyBehavior>
					<Button
						variant="squared"
						color="light"
						size="sm"
						className="shrink-0"
					>
						<Typography weight="semibold">Learn More</Typography>
					</Button>
				</Link>
			</div>
		</div>
	);
};

export default ApeRushBanner;
